module.exports = __webpack_public_path__ + "img/Power-Trip-Logo-12-BLUE.067eda49.png";